(function () {
  var RETAIL_KEY = "Einzelhandelspreis";
  var SAVINGS_KEY = "Sie sparen";

  function inject(items) {
    items.forEach(function (item) {
      var props = item.properties || {};
      var savings = props[SAVINGS_KEY];
      var retail = props[RETAIL_KEY];
      if (!savings) return;

      var lineEl = document.querySelector(
        '#slidecarthq .item[data-line-item-key="' + item.key + '"]'
      );
      if (!lineEl) return;
      if (lineEl.querySelector(".amp-sc__bundle-savings")) return;

      var target = lineEl.querySelector(".main");
      if (!target) return;

      var cleanSavings = savings.split("(")[0].trim();

      var block = document.createElement("div");
      block.className = "amp-sc__bundle-savings";
      block.style.display = "flex";
      block.style.justifyContent = "flex-end";
      block.style.alignItems = "baseline";
      block.style.gap = "6px";
      block.style.width = "100%";
      block.style.marginTop = "4px";

      if (retail) {
        var r = document.createElement("span");
        r.style.fontSize = "13.6px";
        r.style.opacity = "0.7";
        r.style.textDecoration = "line-through";
        r.textContent = retail;
        block.appendChild(r);
      }

      var s = document.createElement("span");
      s.style.fontSize = "13.6px";
      s.style.color = "rgb(0, 193, 84)";
      s.style.whiteSpace = "nowrap";
      s.textContent = "(Sie sparen " + cleanSavings + ")";
      block.appendChild(s);

      target.appendChild(block);
    });
  }

  function renderBundleSavings() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.items) inject(cart.items);
      })
      .catch(function () {});
  }

  window.SLIDECART_LOADED = renderBundleSavings;
  window.SLIDECART_UPDATED = renderBundleSavings;

  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(renderBundleSavings, 800);
  });
  setTimeout(renderBundleSavings, 1500);
})();